// extracted by mini-css-extract-plugin
export default {"headerTopo":"header_headerTopo__hgWxv","headerText":"header_headerText__iFKOF","linha":"header_linha__Mfp4Q"};